<template>
  <div
    class="shadow-sm tw-rounded-lg"
    style="height: 580px; width: 100%; overflow: hidden"
  >
    <div class="tw-flex tw-h-full">
      <div class="tw-w-60 tw-flex-none tw-rounded-lg">
        <div
          class="tw-px-6 tw-pt-4 tw-pb-8 tw-flex tw-flex-col no-select tw-bg-gray-50"
          style="width: 100%; height: 100%"
        >
          <div
            class="tw-flex-none tw-flex tw-items-center tw-cursor-pointer"
            @click="handleClickAllProduct"
          >
            <div class="tw-flex tw-items-center" style="color: #333">
              <img class="tw-w-6 tw-h-6" src="/icon-cp.png" alt="" />
              <span class="tw-ml-2 tw-text-xl tw-font-medium">{{
                $t("全部产品")
              }}</span>
            </div>
          </div>
          <div class="flex-none tw-mt-5">
            <div
              class="tw-relative tw-flex tw-items-center tw-px-3 tw-py-1 tw-border tw-border-gray-300 tw-rounded-full tw-bg-white tw-shadow-sm focus-within:tw-ring-2 focus-within:tw-ring-blue-300"
              style="width: 100%"
            >
              <b-icon
                icon="search"
                class="tw-text-gray-400 tw-w-3.5 tw-h-3.5 tw-cursor-pointer"
              ></b-icon>
              <input
                type="text"
                v-model="productSearchValue"
                autocomplete="off"
                @input="handleSearch"
                @compositionstart="handleCompositionStart"
                @compositionend="handleCompositionEnd"
                :placeholder="$t('搜索产品')"
                class="tw-ml-2 tw-flex-1 tw-outline-none tw-bg-transparent tw-text-gray-700"
                style="font-size: 14px"
              />
            </div>
          </div>
          <div
            class="all-pointer tw-flex-1 tw-flex-col tw-mt-2 tw-overflow-hidden tw-overflow-y-auto"
          >
            <div
              class="menu-item tw-py-3 cursor-pointer"
              v-for="(item, index) in navItems"
              :key="index"
              @mouseenter="handleMouseEnter(item)"
              @mouseleave="handleMouseLeave"
            >
              <span
                class="menu-title"
                :class="{ 'menu-title-active': item.id == activeId }"
              >
                {{ item.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tw-flex-1 tw-h-full tw-overflow-hidden tw-mb-4 tw-pt-4 tw-pb-4"
      >
        <div
          class="hide-scrollbar tw-flex-1 tw-h-full tw-overflow-y-auto tw-mb-4 tw-pl-4"
        >
          <div
            class="tw-flex tw-w-full tw-flex-col tw-pr-4"
            v-if="productSearchValue"
          >
            <b-row class="tw-mb-4 tw-w-full">
              <b-col :cols="12">
                <div class="tw-flex tw-items-center tw-cursor-pointer tw-mb-2">
                  <span class="tw-text-base tw-font-medium" style="color: #333"
                    >{{ productSearchValue }}
                    <span class="tw-text-sm tw-ml-2">{{ $t("的搜索结果") }}</span></span
                  >
                  <b-icon
                    icon="x-lg"
                    class="tw-w-3 tw-h-3 tw-ml-1 tw-cursor-pointer"
                    @click="handleCloseSearch"
                  ></b-icon>
                </div>
              </b-col>
              <b-col
                cols="4"
                xl="3"
                v-for="(child, index2) in productSearchList"
                :key="index2"
              >
                <SelectItem :item="child" @onSelect="handleToProductDetail" />
              </b-col>
            </b-row>
          </div>

          <div class="tw-flex tw-flex-col tw-w-full tw-pr-4" v-else>
            <!-- 数据加载中时显示骨架屏 -->
            <div v-if="loading">
              <big-img selType="23" />
            </div>
            <!-- 无数据时显示占位图 -->
            <div
              v-else-if="
                !productMap[activeId] || productMap[activeId].length === 0
              "
              class="tw-h-full"
            >
              <span class="tw-h-full tw-flex tw-justify-center tw-items-center"
                >{{ $t("暂无产品") }}</span
              >
            </div>
            <b-row
              v-else
              class="tw-mb-4 tw-w-full"
              v-for="(item, index) in productMap[activeId]"
              :key="index"
            >
              <b-col :cols="12">
                <div class="tw-flex tw-items-center tw-mb-2">
                  <div class="tw-cursor-pointer" @click="handleItemClick(item)">
                    <span
                      class="tw-text-lg tw-font-medium"
                      style="color: #333"
                      >{{ item.categoryName }}</span
                    >
                    <!-- <b-icon icon="chevron-right" class="tw-w-4 tw-h-4 tw-ml-1"></b-icon> -->
                  </div>
                </div>
              </b-col>

              <!-- 有产品时显示产品列表 -->
              <b-col
                cols="4"
                xl="3"
                v-for="(child, index2) in item.products"
                :key="index2"
              >
                <SelectItem :item="child" @onSelect="handleToProductDetail" />
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { productsApi, navProductsApi, categoriesApi } from "@/api/modules/home";
import SelectItem from "./components/SelectItem.vue";
import BigImg from "@/components/skeleton/bigImg.vue";
export default {
  name: "ProductMenu",
  components: {
    SelectItem,
    BigImg,
  },
  data() {
    return {
      navItems: [],
      activeId: -1,
      listquery: {
        pageIndex: 1,
        pageSize: 8,
        categoryId: "",
      },
      productMap: {},
      productSearchValue: "",
      productSearchList: [],
      searchTimer: null,
      searchRequestId: 0,
      isComposing: false,
      debounceTimer: null,
      loading: false,
      hoverTimer: null,
    };
  },
  mounted() {
    this.getCategories();
  },
  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
    }
  },
  methods: {
    // 获取产品分类列表
    async getCategories() {
      const indexInfo = localStorage.getItem("indexInfo");
      const cate = indexInfo ? JSON.parse(indexInfo).categoryTree : [];
      if (cate.length) {
        this.navItems = cate;
      } else {
        // 获取产品分类列表
        const res = await categoriesApi();
        if (res && res.data && res.data.length) {
          this.navItems = res.data;
        }
      }
      this.navItems.unshift({
        id: -1, // 做推荐的临时id
        name: this.$t("推荐产品"),
      });
      this.handleClick(this.navItems[0]);
    },
    handleClickAllProduct() {
      this.$emit("handleToDetail", null);
      this.$router.push("/product");
    },
    handleMouseEnter(item) {
      this.hoverTimer = setTimeout(() => {
        this.handleClick(item);
      }, 300);
    },
    handleMouseLeave() {
      // 鼠标离开时清除定时器
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
    },
    handleClick(item) {
      this.activeId = item.id;
      if (item.id === -1) {
        this.listquery.categoryId = "";
        this.listquery.isRecommend = 1;
      } else {
        this.listquery.categoryId = item.id;
        this.listquery.isRecommend = "";
      }
      this.listquery.pageIndex = 1;
      this.listquery.pageSize = 20;

      if (this.productMap[this.activeId]) {
        return;
      }

      // 设置加载状态
      this.loading = true;

      // 防抖处理
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.getProducts();
      }, 100);
    },
    getProducts() {
      const currentId = this.activeId;

      if (this.productMap[currentId]) {
        this.loading = false;
        return;
      }
      if (currentId !== -1) {
        navProductsApi(this.listquery)
          .then((res) => {
            if (res && res.data) {
              if (this.activeId !== currentId) return;
              this.$set(this.productMap, currentId, res.data);
            }
          })
          .finally(() => {
            // 无论成功还是失败都清除加载状态
            this.loading = false;
          });
      } else {
        productsApi(this.listquery)
          .then((res) => {
            if (res && res.data) {
              if (this.activeId !== currentId) return;

              this.$set(this.productMap, currentId, [
                {
                  categoryId: currentId,
                  categoryName: this.$t("推荐产品"),
                  products: res.data.list || [],
                },
              ]);
            }
          })
          .finally(() => {
            // 无论成功还是失败都清除加载状态
            this.loading = false;
          });
      }
    },
    handleToProductDetail(item) {
      this.productSearchValue = "";
      localStorage.setItem("detailForm", JSON.stringify(item));
      this.$emit("handleToDetail", item);
      // 如果是审计分类 跳单次服务页
      if (item.categoryId === 90) {
        this.$router.push(`/single-product/${item.id}?isApi=false`);
      } else {
        this.$router.push(`/product/${item.id}?isApi=false`);
      }
    },
    handleItemClick(item) {
      this.$emit("handleToDetail", null);
      if (item.categoryId === -1) {
        this.$router.push("/product");
      } else {
        this.$router.push({
          name: "product",
          query: { categoryId: item.categoryId },
        });
      }
    },
    handleSearch(event) {
      // 中文输入法选词完成前不搜索，避免拼音字母产生多次无效请求。
      if (this.isComposing || event?.isComposing) return;

      const keyword = String(event?.target?.value ?? this.productSearchValue).trim();
      const requestId = ++this.searchRequestId;

      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.productSearchList = [];
      if (!keyword) return;

      this.searchTimer = setTimeout(async () => {
        try {
          const res = await productsApi({
            pageIndex: 1,
            pageSize: 100,
            searchWord: keyword,
          });

          // 输入变化后丢弃旧请求，避免较慢的全量/旧关键词结果覆盖最新结果。
          if (
            requestId !== this.searchRequestId ||
            keyword !== this.productSearchValue.trim()
          ) {
            return;
          }

          const list = Array.isArray(res?.data?.list) ? res.data.list : [];
          const normalizedKeyword = keyword.toLocaleLowerCase();

          // 产品接口还会搜索富文本详情。导航卡片只展示名称和简介，因此在前端
          // 对可见内容做最终校验，避免隐藏详情命中时看起来像“返回全部产品”。
          this.productSearchList = list.filter((item) => {
            const visibleText = `${item?.name || ""} ${item?.desc || ""}`
              .toLocaleLowerCase();
            return visibleText.includes(normalizedKeyword);
          });
        } catch (error) {
          if (requestId === this.searchRequestId) {
            this.productSearchList = [];
          }
        }
      }, 300);
    },
    handleCompositionStart() {
      this.isComposing = true;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.searchRequestId += 1;
    },
    handleCompositionEnd(event) {
      this.isComposing = false;
      this.productSearchValue = event?.target?.value || "";
      this.handleSearch(event);
    },
    handleCloseSearch() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.searchRequestId += 1;
      this.isComposing = false;
      this.productSearchValue = "";
      this.productSearchList = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-item:hover {
  color: #4077f8;
}

.menu-title-active {
  color: #4077f8;
}

.item-c:hover {
  border-radius: 6px;
  box-shadow: 0 0 10px 0 rgba(64, 119, 248, 0.2);

  .item-title {
    color: #4077f8 !important;
  }
}
.all-pointer {
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-button {
    display: none; /* 隐藏上下箭头 */
  }

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}
</style>
